import {
  yleConsentSdkHeadless,
  Environment,
} from '@yleisradio/consent-sdk/headless';
import { useCallback } from 'react';
import { shouldRedirectToConsentView } from '../CookieConsent/utils';
import { isTestRuntime } from '../../common/utils';
import { useNavigateWithHistory } from '../Routes/useNavigateWithHistory';
import { CONSENT_PATH } from '../Routes/routeNames';
import { useLocationWithState } from '../Routes/useLocationWithState';
import { LoggedInUser } from '../../common/types';

const isTestRunner = () => typeof jest !== 'undefined';

export const useYleConsentSdk = (introVideoShown: boolean) => {
  const navigate = useNavigateWithHistory();
  const location = useLocationWithState();

  const initConsentSdk = async (
    vrsDevice: string,
    user: LoggedInUser | undefined
  ) => {
    const environment: Environment = isTestRuntime() ? 'test' : 'prod';
    const args = {
      environment,
      initiatingApp: vrsDevice,
    };

    if (!yleConsentSdkHeadless?.initialized && !isTestRunner()) {
      await yleConsentSdkHeadless?.init(args);

      /*
        consent needs to be updated if:
        - consent is not set (null)
        - consent is set but it is not valid (consent is expired)
      */

      const consentNeedsToBeUpdated =
        user && yleConsentSdkHeadless._consentNeedsToBeUpdated;

      if (consentNeedsToBeUpdated) {
        if (shouldRedirectToConsentView(location.pathname) && introVideoShown) {
          navigate(`/${CONSENT_PATH}`);
        }
      }
    }
  };

  return {
    initConsentSdk: useCallback(initConsentSdk, [
      location.pathname,
      navigate,
      introVideoShown,
    ]),
  };
};
